import React from 'react';
import * as api from '../../api/facility'
import PageList from '../../components/PageListAPI'
import { useCan } from '../../hooks/useCan';
import { SLUGS } from '../../enum/permissions.enum';

export default function FacilityList(props) {
  const can = useCan()
  return (
    <div className='App-paper'>
      <PageList
        name='facility'
        title='Список объектов'
        columns={[{ id: 'name', name: 'Название' }, { id: 'address', name: 'Адрес' }]}
        createItem={can(SLUGS.FACILITY.CREATE)}
        deleteItem={can(SLUGS.FACILITY.DELETE)}
        idName='id'
        loadAPI={{
          request: api.getFacility
        }
        }
        deleteAPI={api.deleteFacility}
        {...props}
      />
    </div>
  )
}